import create from 'zustand';

export const useSidebarStore = create((set) => ({
  // Login sidebar state
  isLoginSidebarOpen: false,
  setLoginSidebarOpen: (isOpen) => set({ isLoginSidebarOpen: isOpen }),
  toggleLoginSidebar: () => set((state) => ({ isLoginSidebarOpen: !state.isLoginSidebarOpen })),
  
  // Logged in sidebar state
  isLoggedInSidebarOpen: false,
  setLoggedInSidebarOpen: (isOpen) => set({ isLoggedInSidebarOpen: isOpen }),
  toggleLoggedInSidebar: () => set((state) => ({ isLoggedInSidebarOpen: !state.isLoggedInSidebarOpen })),
  
  // SSO Register sidebar state
  ssoRegisterSidebar: { isOpen: false, provider: "" },
  setSsoRegisterSidebar: (ssoState) => set({ ssoRegisterSidebar: ssoState }),
  setSsoRegisterSidebarOpen: (isOpen) => set((state) => ({ 
    ssoRegisterSidebar: { ...state.ssoRegisterSidebar, isOpen } 
  })),
}));
